import { useEffect } from 'react';
import { type RecentItem, pushRecent } from '#client/lib/recent';

/**
 * Records a record the user opened in their recent list.
 *
 * An effect, not a write during render: rendering must stay free of side
 * effects, and Strict Mode or a concurrent re-render would otherwise write the
 * same entry more than once. Re-runs only when what would be written changes.
 */
export function useRecordRecent(userId: number | undefined, item: RecentItem): void {
  const { href, title, subtitle } = item;

  useEffect(() => {
    pushRecent(userId, { href, title, ...(subtitle === undefined ? {} : { subtitle }) });
  }, [userId, href, title, subtitle]);
}
